import type { ComponentProps } from 'react';
import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { ScarcityIcon } from '#src/atoms/icons/ScarcityIcon/index.tsx';
import { OverlapItems } from '#src/atoms/ui/OverlapItems/index.tsx';

const StyledOverlapItems = styled(OverlapItems)`
  align-items: initial;
`;

type Props = {
  rarities: Rarity[];
  size?: ComponentProps<typeof ScarcityIcon>['size'];
};

export const Scarcities = ({ rarities, size = 3 }: Props) => {
  return (
    <StyledOverlapItems reverse offset={9}>
      {rarities.map(rarity => (
        <ScarcityIcon key={rarity} rarity={rarity} size={size} />
      ))}
    </StyledOverlapItems>
  );
};
